module.exports = __webpack_public_path__ + "img/mkr.216efb8d.svg";